import { LocalStorageService } from "src/app/utils/localstorage.service";
import { Subscription } from "rxjs";

import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  Input,
  OnChanges,
  SimpleChanges,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { DragulaService } from "ng2-dragula";
import { DashboardService } from "src/app/dashboard/dashboard.service";

import { Job } from "../job.model";
import { JobsStore } from "../jobs.store";
import { JobsService } from "../jobs.service";
import { LazyLoadEvent, SharedModule } from "primeng/api";
import * as FileSaver from "file-saver";
import autoTable from "jspdf-autotable";
import { Table, TableModule } from "primeng/table";
import { WorkSheet } from "xlsx";
import { SharedDataService } from "src/app/dashboard/shared-data.service";
import { MomentModule } from "ngx-moment";
import { TagComponent } from "../../../common/tags/tag.component";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { NgIf, NgClass, NgFor } from "@angular/common";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { EmptyStateComponent } from "src/app/design-system/components/empty-state/empty-state.component";
import { JobsGroupsDueComponent } from "../jobs-groups-due/jobs-groups-due.component";

@Component({
  selector: "ch-job-list-view",
  templateUrl: "./job-list-view.component.html",
  styleUrls: ["./job-list-view.component.scss"],
  imports: [
    BsDropdownModule,
    TableModule,
    SharedModule,
    NgIf,
    NgClass,
    TooltipModule,
    NgFor,
    TagComponent,
    MomentModule,
    EmptyStateComponent,
    JobsGroupsDueComponent,
  ],
})
export class JobsListViewComponent implements OnInit, OnChanges, OnDestroy {
  @Input() jobs: [];
  @Input() filters;
  @Input() isCompletedFilterSelected: boolean;
  private exportExcelSubscription: Subscription;
  @Input() exportExcelEvent: EventEmitter<void>;
  private exportPdfSubscription: Subscription;
  @Input() exportPdfEvent: EventEmitter<void>;
  private exportCsvSubscription: Subscription;
  @Input() exportCsvEvent: EventEmitter<void>;

  first = 0;
  selectedJobs: Job[];
  lastSelectedJob: Job = null;
  lastLazyEvent: LazyLoadEvent;

  totalRecords = 0;
  loading = false;
  dashboardName = "jobsDashboard";

  @ViewChild("dt", { static: true }) public dt: Table;

  cols = [
    { field: "client", header: "Client" },
    { field: "name", header: "Name" },
    { field: "assigned_to", header: "Assigned To" },
    { field: "start_date", header: "Start Date" },
    { field: "due_date", header: "Due Date" },
    { field: "completed_date", header: "Completed Date" },
    { field: "status", header: "Status" },
    { field: "tasks_done", header: "Tasks" },
    { field: "client_tasks_done", header: "Client Tasks" },
  ];
  exportColumns: any[];

  constructor(
    private jobsService: JobsService,
    public jobsStore: JobsStore,
    public sharedDataService: SharedDataService,
    private cdr: ChangeDetectorRef,
    public dashboardService: DashboardService,
  ) {}

  ngOnInit() {
    this.exportColumns = this.cols.map((col) => col.header);
    this.jobsService.jobContentClosed.subscribe((res) => {
      console.log("content closed");
      this.dt.reset();

      setTimeout(() => {
        console.log("loadjobs settimeout");
        this.dt.sortField =
          this.dashboardService.filters()[this.dashboardName].sortField;
        this.dt.sortOrder =
          this.dashboardService.filters()[this.dashboardName].sortOrder;
        this.dt.first = this.first;
        this.dt.sortSingle();
      }, 300);
    });

    this.exportExcelSubscription = this.exportExcelEvent.subscribe(() => {
      this.exportExcel();
    });
    this.exportPdfSubscription = this.exportPdfEvent.subscribe(() => {
      this.exportPdf();
    });
    this.exportCsvSubscription = this.exportCsvEvent.subscribe(() => {
      this.exportCsv();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // reset selection
    this.selectedJobs = [];
    console.log("changes", changes);
    if (changes.filters.previousValue != null) {
      if (
        changes.filters.previousValue.selectedDateFilter !=
          "completed_7_days" &&
        changes.filters.previousValue.selectedDateFilter != "completed_30_days"
      ) {
        if (
          changes.filters.currentValue.selectedDateFilter ==
            "completed_7_days" ||
          changes.filters.currentValue.selectedDateFilter == "completed_30_days"
        ) {
          // this.dt.sortField = "completed_date";
          // this.dt.sortOrder = -1;
          this.dashboardService.filters.update((prevState) => ({
            ...prevState,
            [this.dashboardName]: {
              ...prevState[this.dashboardName],
              sortField: "completed_date",
              sortOrder: -1,
            },
          }));
        }
      }

      if (changes.filters != null) {
        this.dt.sortSingle();
      }
    }
  }

  ngOnDestroy() {
    this.exportExcelSubscription?.unsubscribe();
    this.exportPdfSubscription?.unsubscribe();
    this.exportCsvSubscription?.unsubscribe();
  }

  showCompletedDate() {
    if (this.filters.selectedDateFilter == "completed") {
      return true;
    }
    return false;
  }

  loadJobs(lazyEvent: LazyLoadEvent) {
    console.log("loadjobs", lazyEvent);
    /* filters: {name: Array(1), assigned_to: Array(1), due_date: Array(1), status: Array(1)}
    first: 0
    globalFilter: null
    multiSortMeta: undefined
    rows: 10
    sortField: undefined
    sortOrder: 1 */
    this.loading = true;

    this.lastLazyEvent = lazyEvent;

    const completedFilter = this.isCompletedFilterSelected
      ? this.filters.selectedCompletedFilter
      : null;

    const dueDateFilter = completedFilter ? null : this.filters.dueDateFilter;
    console.log(this.filters);

    this.jobsService
      .getJobList(
        this.filters.selectedFilter,
        null,
        this.filters.job_tags_filter,
        this.filters.workspace_tags_filter,
        this.filters.selectedDateFilter,
        lazyEvent.first,
        lazyEvent.rows,
        lazyEvent.sortField,
        lazyEvent.sortOrder,
        this.filters.andOrWorkspaces,
        this.filters.andOrJobs,
        this.filters.clientFilter,
        false,
        completedFilter,
        dueDateFilter,
      )
      .subscribe((res) => {
        this.jobs = res.jobs;
        this.totalRecords = res.total_count;
        this.loading = false;
        this.cdr.detectChanges();
      });
  }

  onPageChange(event) {
    this.dashboardService.filters.update((prevState) => ({
      ...prevState,
      [this.dashboardName]: {
        ...prevState[this.dashboardName],
        rows: event.rows,
      },
    }));
  }

  exportPdf() {
    console.log({
      selectedFilter: this.filters.selectedFilter,
      nullValue: null,
      jobTagsFilter: this.filters.job_tags_filter,
      workspaceTagsFilter: this.filters.workspace_tags_filter,
      selectedDateFilter: this.filters.selectedDateFilter,
      first: this.lastLazyEvent.first,
      rows: this.lastLazyEvent.rows,
      sortField: this.lastLazyEvent.sortField,
      sortOrder: this.lastLazyEvent.sortOrder,
      andOrWorkspaces: this.filters.andOrWorkspaces,
      andOrJobs: this.filters.andOrJobs,
    });
    const completedFilter = this.isCompletedFilterSelected
      ? this.filters.selectedCompletedFilter
      : null;

    const dueDateFilter = completedFilter ? null : this.filters.dueDateFilter;
    this.loading = true;
    this.jobsService
      .getJobList(
        this.filters.selectedFilter,
        null,
        this.filters.job_tags_filter,
        this.filters.workspace_tags_filter,
        this.filters.selectedDateFilter,
        this.lastLazyEvent.first,
        this.lastLazyEvent.rows,
        this.lastLazyEvent.sortField,
        this.lastLazyEvent.sortOrder,
        this.filters.andOrWorkspaces,
        this.filters.andOrJobs,
        this.filters.clientFilter,
        true,
        completedFilter,
        dueDateFilter,
      )
      .subscribe((res) => {
        let allJobs = res.jobs;

        import("jspdf").then((jsPDF) => {
          import("jspdf-autotable").then((x) => {
            const doc = new jsPDF.default("l", "pt");
            autoTable(doc, {
              head: [this.exportColumns],
              body: allJobs.map((job: Job) => {
                let tasks_done_text = `${
                  job["tasks_count"] - job["undone_tasks_count"]
                }/${job["tasks_count"]} tasks`;
                let client_tasks_done_text = `${
                  job["client_tasks_count"] - job["undone_client_tasks_count"]
                }/${job["client_tasks_count"]} client tasks`;

                let status = "";
                //switch case for status
                switch (job.status) {
                  case 0:
                    status = "Not Started";
                    break;
                  case 1:
                    status = "In progress";
                    break;
                  case 2:
                    status = "On Hold";
                    break;
                  case 3:
                    status = "Completed";
                    break;
                }

                return [
                  job.client_company["name"],
                  job.name,
                  job?.assigned_to["full_name"],
                  job.target_start_date,
                  job.due_date,
                  status,
                  job?.completed_date,
                  tasks_done_text,
                  client_tasks_done_text,
                ];
              }),
            });
            doc.save(
              `jobs_dashboard_${new Date()
                .toDateString()
                .replace(" ", "_")}.pdf`,
            );
          });
        });

        this.loading = false;
        this.cdr.detectChanges();
      });
  }

  exportExcel() {
    this.loading = true;
    const completedFilter = this.isCompletedFilterSelected
      ? this.filters.selectedCompletedFilter
      : null;

    const dueDateFilter = completedFilter ? null : this.filters.dueDateFilter;

    this.jobsService
      .getJobList(
        this.filters.selectedFilter,
        null,
        this.filters.job_tags_filter,
        this.filters.workspace_tags_filter,
        this.filters.selectedDateFilter,
        this.lastLazyEvent.first,
        this.lastLazyEvent.rows,
        this.lastLazyEvent.sortField,
        this.lastLazyEvent.sortOrder,
        this.filters.andOrWorkspaces,
        this.filters.andOrJobs,
        this.filters.clientFilter,
        true,
        completedFilter,
        dueDateFilter,
      )
      .subscribe((res) => {
        let allJobs = res.jobs;

        import("xlsx").then((xlsx) => {
          let formattedJobs = allJobs.map((job: Job) => {
            let tasks_done_text = `${
              job["tasks_count"] - job["undone_tasks_count"]
            }/${job["tasks_count"]} tasks`;
            let client_tasks_done_text = `${
              job["client_tasks_count"] - job["undone_client_tasks_count"]
            }/${job["client_tasks_count"]} client tasks`;

            let status = "";
            switch (job.status) {
              case 0:
                status = "Not Started";
                break;
              case 1:
                status = "In progress";
                break;
              case 2:
                status = "On Hold";
                break;
              case 3:
                status = "Completed";
                break;
            }

            return {
              client: job.client_company["name"],
              name: job.name,
              assigned_to: job?.assigned_to["full_name"],
              start_date: job.target_start_date,
              due_date: job.due_date,
              status: status,
              completed_date: job?.completed_date,
              tasks: tasks_done_text,
              client_tasks: client_tasks_done_text,
            };
          });
          console.log("EXPORT COLUMNS", this.exportColumns);
          const wb = xlsx.utils.book_new();
          const ws: WorkSheet = xlsx.utils.json_to_sheet([]);
          xlsx.utils.sheet_add_aoa(ws, [this.exportColumns]);

          xlsx.utils.sheet_add_json(ws, formattedJobs, {
            origin: "A2",
            skipHeader: true,
          });

          xlsx.utils.book_append_sheet(wb, ws, "Sheet1");
          xlsx.writeFile(
            wb,
            `jobs_dashboard_${new Date().toDateString()}.xlsx`,
          );

          this.loading = false;

          // this.saveAsExcelFile(file, "jobs");
        });
      });
  }

  async exportCsv(): Promise<void> {
    this.loading = true;

    const completedFilter = this.isCompletedFilterSelected
      ? this.filters.selectedCompletedFilter
      : null;

    const dueDateFilter = completedFilter ? null : this.filters.dueDateFilter;

    this.loading = true;
    this.jobsService
      .getJobList(
        this.filters.selectedFilter,
        null,
        this.filters.job_tags_filter,
        this.filters.workspace_tags_filter,
        this.filters.selectedDateFilter,
        this.lastLazyEvent.first,
        this.lastLazyEvent.rows,
        this.lastLazyEvent.sortField,
        this.lastLazyEvent.sortOrder,
        this.filters.andOrWorkspaces,
        this.filters.andOrJobs,
        this.filters.clientFilter,
        true,
        completedFilter,
        dueDateFilter,
      )
      .subscribe(({ jobs }) => {
        console.log("THE JOBS", jobs);
        let csvContent = "data:text/csv;charset=utf-8,";
        const exportCols = this.exportColumns;
        csvContent += exportCols.join(",") + "\n";
        jobs.forEach((job) => {
          let tasks_done_text = `${
            job["tasks_count"] - job["undone_tasks_count"]
          }/${job["tasks_count"]} tasks`;
          let client_tasks_done_text = `${
            job["client_tasks_count"] - job["undone_client_tasks_count"]
          }/${job["client_tasks_count"]} client tasks`;

          let status = "";
          switch (job.status) {
            case 0:
              status = "Not Started";
              break;
            case 1:
              status = "In progress";
              break;
            case 2:
              status = "On Hold";
              break;
            case 3:
              status = "Completed";
              break;
          }
          const rowData = [
            job.client_company["name"],
            job.name,
            job?.assigned_to["full_name"],
            job.target_start_date,
            job.due_date,
            job?.completed_date,
            status,
            tasks_done_text,
            client_tasks_done_text,
          ];
          csvContent += rowData.join(",") + "\n";
        });
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute(
          "download",
          `jobs_dashboard_data_dashboard_${new Date()
            .toDateString()
            .replace(" ", "_")}.csv`,
        );
        document.body.appendChild(link);
        link.click();
        this.loading = false;
      });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      `jobs_dashboard_${new Date()
        .toDateString()
        .replace(" ", "_")}${EXCEL_EXTENSION}`,
    );
  }

  selectJob(job: Job, ev) {
    console.log(ev);
    if (job.uuid === this.lastSelectedJob?.uuid) {
      this.lastSelectedJob = null;
      return;
    }

    if (
      ev.target.classList.value.indexOf("p-checkbox-box") == -1 &&
      ev.target.classList.value.indexOf("p-checkbox-icon") == -1
    ) {
      this.jobsService.setSelectedJobOnDashboard.next(job);
      this.lastSelectedJob = job;
    }
  }

  notifyJobSelectionChange() {
    this.jobsService.jobsSelectionArray.next(this.selectedJobs);
    this.lastSelectedJob = null;
  }

  onSort(event: any) {
    this.dashboardService.filters.update((prevState) => ({
      ...prevState,
      [this.dashboardName]: {
        ...prevState[this.dashboardName],
        sortField: event.field,
        sortOrder: event.order,
      },
    }));
  }

  onPage(event: any) {
    this.first = event.first;
  }

  onCheckboxClick(job, $event) {
    $event.stopPropagation();
  }
}
